import { render, staticRenderFns } from "./spareRequirementsAdd.vue?vue&type=template&id=5f2f2715&scoped=true"
import script from "./spareRequirementsAdd.vue?vue&type=script&lang=js"
export * from "./spareRequirementsAdd.vue?vue&type=script&lang=js"
import style0 from "./spareRequirementsAdd.vue?vue&type=style&index=0&id=5f2f2715&prod&lang=scss&scoped=true"
import style1 from "./spareRequirementsAdd.vue?vue&type=style&index=1&id=5f2f2715&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2f2715",
  null
  
)

export default component.exports